<mat-card *ngIf="room$ | async | ready as room">
  <mat-card-header>
    <mat-card-title class="flex flex-row gap-[5px] justify-start items-center">
      <div class="room-name">
        {{ room | value2: featurePropertyKey.name }}
      </div>
      <button
        mat-icon-button
        class="edit-btn"
        gtm="onOpen"
        gtmAction="Edit room modal"
        gtmCategory="manageRoom"
        (click)="openEditRoomDialog(room)"
      >
        <mat-icon>create</mat-icon>
      </button>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="flex flex-col gap-[4px]">
    <div *ngFor="let device of room?.properties?.actors?.value" class="device-panel">
      <div class="flex flex-row gap-[4px] justify-between items-center">
        <div class="flex flex-row gap-[16px] justify-start items-center flex-[100%] max-w-[100%]">
          <mat-icon class="btn-device-assigned">done</mat-icon>
          <div class="device-id lt-md:flex lt-md:flex-col lt-md:justify-start lt-md:items-start">
            <span>
              {{ gatewayStore.getDeviceRoles(device.deviceId) | async | translateDeviceByRoles }}
            </span>
            <span>
              {{ device.deviceId | idPrefixRemover | serialSpacing }}
            </span>
          </div>
        </div>
        <div
          *ngIf="
            installationFeaturesStore.canRemoveClimateAndCo2SensorFromRoom(roomFeature) | async;
            else infoBlock
          "
          class="icons-panel flex flex-row justify-end items-center"
        >
          <button
            data-at-comissioning-btn-unassign-device
            mat-icon-button
            class="modal-icon"
            matTooltip="{{ '+COMMISSIONING.ROOM.TOOLTIP.DELETE_DEVICE' | translate }}"
            [viConfirm]="{
              title: '+COMMISSIONING.DELETE_DEVICE_FROM_ROOM.CONFIRM.TITLE' | translate,
              content: '+COMMISSIONING.DELETE_DEVICE_FROM_ROOM.CONFIRM.CONTENT' | translate,
              cancelBtn: 'GENERAL.BUTTON.CANCEL' | translate,
              confirmBtn: 'GENERAL.BUTTON.DELETE' | translate
            }"
            gtm="onOpen"
            gtmAction="Unassign device from room confirmation modal"
            gtmCategory="manageRoom"
            (confirm)="onUnassignDeviceFromRoom(device.deviceId, room)"
            (cancel)="cancelUnassignDeviceFromRoomConfirmation()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <ng-template #infoBlock>
          <div class="flex flex-row justify-end items-center flex-1">
            <mat-icon
              class="warning-icon"
              matTooltip="{{
                '+COMMISSIONING.DEVICE.TOOLTIP.INFO_REMOVE_CLIMATE_CO2_SENSOR_FROM_ROOM' | translate
              }}"
              >error_outline</mat-icon
            >
          </div>
        </ng-template>
      </div>
    </div>

    <div *ngFor="let assignableDevice of gatewayStore.assignableDevices$ | async">
      <div *ngFor="let device of assignableDevice.devices" class="device-panel">
        <ng-container *ngIf="commissioningService.isVitotrol300EDevice(device); else notVT300Ebtn">
          <div class="flex flex-row justify-between">
            <div class="device-id lt-md:flex lt-md:flex-col lt-md:justify-start lt-md:items-start">
              <span>{{ device?.roles | translateDeviceByRoles }} </span>
              <span>{{ device?.id | idPrefixRemover | serialSpacing }}</span>
            </div>
            <mat-icon
              class="warning-icon"
              *ngIf="commissioningService.invalidVitotrolToAssignRoom(device)"
              [matTooltip]="'+COMMISSIONING.ROOM.TOOLTIP.RC_CANT_ASSIGN_TO_ROOM' | translate"
            >
              error_outline
            </mat-icon>
            <button
              mat-icon-button
              *ngIf="!commissioningService.invalidVitotrolToAssignRoom(device)"
              gtm="onAddDeviceToRoom"
              matTooltip="{{ '+COMMISSIONING.ROOM.TOOLTIP.ADD_DEVICE' | translate }}"
              (click)="onAdd(device)"
              class="modal-icon"
            >
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </ng-container>
        <ng-template #notVT300Ebtn>
          <div
            class="flex flex-row justify-between items-center"
            *ngrxLet="
              installationFeaturesStore.getAddActorConstraints(
                room,
                device.id
              ) as constraintViolation
            "
          >
            <div class="device-id lt-md:flex lt-md:flex-col lt-md:justify-start lt-md:items-start">
              <span>{{ device?.roles | translateDeviceByRoles }} </span>
              <span>{{ device?.id | idPrefixRemover | serialSpacing }}</span>
            </div>
            <div class="icons-panel flex flex-row justify-end items-center">
              <mat-icon
                class="warning-icon"
                *ngIf="constraintViolation"
                [matTooltip]="
                  '+COMMISSIONING.ROOM.TOOLTIP.ADD_DEVICE_DISABLED.' + constraintViolation
                    | translate
                "
              >
                error_outline
              </mat-icon>
              <button
                mat-icon-button
                *ngIf="!constraintViolation"
                gtm="onAddDeviceToRoom"
                matTooltip="{{ '+COMMISSIONING.ROOM.TOOLTIP.ADD_DEVICE' | translate }}"
                (click)="onAdd(device)"
                class="modal-icon"
              >
                <mat-icon>add</mat-icon>
              </button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </mat-card-content>
  <mat-card-actions class="flex flex-row gap-[8px] justify-end items-center">
    <button
      mat-raised-button
      gtm="onConfirm"
      gtmCategory="room"
      gtmAction="Add device or channel"
      color="primary"
      (click)="onAddNewDevice(room)"
    >
      {{ 'GENERAL.BUTTON.ADD_DEVICE' | translate }}
    </button>
    <button
      mat-button
      gtm="onCancelDialog"
      gtmCategory="manageRoom"
      color="primary"
      (click)="onCancel()"
    >
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
